import { Box, Tooltip } from '@mui/material';
import BallotIcon from '@mui/icons-material/Ballot';
import { useTranslation } from 'react-i18next';
import OpenAmountBadge from './OpenAmountBadge';

const EntryConst = ({ unit, value, className, item, showOpenAmount }) => {
  const { t } = useTranslation();

  return (
    <Box className={'flex items-center ' + className} sx={{ height: '26px' }}>
      {item && item.isOrderPosition && (
        <Tooltip title={t('Position from order')}>
          <BallotIcon className="mr-2" />
        </Tooltip>
      )}
      <div className="text-left  w-full">
        {value} {unit}
      </div>
      {showOpenAmount && <OpenAmountBadge item={item} />}
    </Box>
  );
};

export default EntryConst;
